import resetPasswordPageAction from '@commonJs/actions/resetPasswordPageAction';

$(document).ready(resetPasswordPageAction('/portal/api/checkCode'));

$('#resetPass').on('hidden.bs.modal', function () {
    location.href = '/';
});
